// Normaliza o esquema de uma URL para evitar bloqueio de conteúdo misto.
// Quando a página está em https e a URL vem como http://, sobe para https://.
// Em página http, ou para valores vazios/não-string, devolve como está.
// Caso de uso: logo do cliente (endereco_logotipo) gravado com http no banco.
export const normalizarEsquemaUrl = (url) => {
  if (typeof url !== 'string' || url === '') {
    return url
  }

  if (window.location.protocol === 'https:' && url.startsWith('http://')) {
    return `https://${url.slice('http://'.length)}`
  }

  return url
}
